import {
  GET_LEVEL_UP_REWARDS,
  OPEN_LEVEL_UP_REWARD_DIALOG,
  CLOSE_LEVEL_UP_REWARD_DIALOG,
  EDIT_LEVEL_UP_REWARD,
  ADD_LEVEL_UP_REWARD,
  DELETE_LEVEL_UP_REWARD,
} from "./types";

const initialState = {
  levelUpRewards: [],
  dialog: false,
  dialogData: null,
};

const levelUpRewardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LEVEL_UP_REWARDS:
      return {
        ...state,
        levelUpRewards: action.payload,
      };
    case EDIT_LEVEL_UP_REWARD:
      return {
        ...state,
        levelUpRewards: state.levelUpRewards.map((level) => {
          if (level._id === action.payload.id) return action.payload.data;
          else return level;
        }),
      };
    case OPEN_LEVEL_UP_REWARD_DIALOG:
      return {
        ...state,
        dialog: true,
        dialogData: action.payload || null,
      };
    case ADD_LEVEL_UP_REWARD:
      console.log("Adding Level Up Reward:", action.payload);
      return {
        ...state,
        levelUpRewards: state.levelUpRewards.map((level) => {
          if (level._id === action.payload._id) return action.payload;
          else return level;
        }),
      };
    case DELETE_LEVEL_UP_REWARD:
      return {
        ...state,
        levelUpRewards: state.levelUpRewards.map((level) => {
          if (level._id === action.payload._id) return action.payload;
          else return level;
        }),
      };
    case CLOSE_LEVEL_UP_REWARD_DIALOG:
      return {
        ...state,
        dialog: false,
        dialogData: null,
      };

    default:
      return state;
  }
};

export default levelUpRewardReducer;
